export const floatRight = {float: 'right', marginLeft: "0.25em"};